<div class="stream-item-comments">
  <div class="stream-item-comments-header" *ngIf="hasMore">
    <ng-container *ngIf="loadingMoreComments">
      <div class="loading-container">
        <mat-spinner [diameter]="16"></mat-spinner>
      </div>
    </ng-container>
    <ng-container *ngIf="!loadingMoreComments">
      <a class="comment-toggle" (click)="loadMoreComments()">
        {{ 'FRONTEND.LOOP.LOAD_MORE_COMMENTS' | translate }}
      </a>
    </ng-container>
  </div>
  <div class="stream-item-comments-list">
    <div>
      <ng-container *ngFor="let comment of comments">
        <sales-common-loop-v2-comment [comment]="comment" [iconSize]="iconSize"></sales-common-loop-v2-comment>
      </ng-container>
    </div>
  </div>
</div>
<div class="stream-item-write-comment">
  <div class="stream-item-user-image">
    <!-- TODO: User image if available instead of icon -->
    <va-icon [iconName]="currentUserName" [diameter]="iconSize" [matTooltip]="currentUserName"></va-icon>
  </div>
  <mat-form-field class="comment-box" appearance="outline">
    <mat-label>{{ 'FRONTEND.LOOP.ADD_A_COMMENT' | translate }}</mat-label>
    <textarea
      matInput
      (keypress)="handleInput($event)"
      cdkTextareaAutosize
      [disabled]="commenting"
      [(ngModel)]="newCommentText"
      maxlength="5000"
      voiceTextArea
      #textArea
      [htmlTextAreaElement]="textArea"
    ></textarea>
    <mat-hint>{{ 'FRONTEND.LOOP.NEW_COMMENT_TOOLTIP' | translate }}</mat-hint>
  </mat-form-field>
</div>
